export default "__VITE_ASSET__CqbEGO32__"